import { ReactNode } from 'react';
import classes from 'classnames';
import styles from './Typography.module.scss';

export type Props = {
  children?: ReactNode;
  className?: string;
  dataTest?: string;
  size?: 'xs' | 's' | 's2' | 'm' | 'l' | 'xl' | 'xxl';
  fontWeight?: 100 | 200 | 300 | 400 | 500 | 600 | 700;
  kind?: 'p' | 'h3' | 'h2' | 'h1' | 'div';
  color?: 'primary' | 'secondary' | 'muted' | 'auxiliary' | 'blue';
  html?: string | TrustedHTML;
  centered?: boolean;
};

function Typography({
  children,
  className,
  dataTest,
  size = 's',
  kind = 'p',
  fontWeight,
  color,
  html,
  centered,
}: Props) {
  const Text = kind as keyof React.JSX.IntrinsicElements;

  return (
    <Text
      className={classes(
        centered && styles.centered,
        styles.typography,
        styles[`size-${size}`],
        fontWeight && styles[`weight-${fontWeight}`],
        color && styles[`color-${color}`],
        className,
      )}
      data-test={dataTest}
      dangerouslySetInnerHTML={html ? { __html: html } : undefined}
    >
      {children as React.JSX.Element}
    </Text>
  );
}

export default Typography;
